import { useState, useLayoutEffect } from "react";
import Button from "../Button/Button";
import { collection, getDocs, query, where, getFirestore } from "firebase/firestore";
import { initializeApp } from "firebase/app";
import { app } from "../../functions/firebaseInit";
import "./ChangeUsername.css";

export default function ChangeUsername(props) {
    const firestore = getFirestore(initializeApp(app));

    const [displayName, setDisplayName] = useState(props.displayName);
    const [nameFind, setNameFind] = useState({ text: "", status: null });

    // check availability of inputted display name    
    useLayoutEffect(() => {
        const timer = setTimeout(async () => {
            if (displayName.length > 0 && displayName.toLowerCase() !== props.displayNameLower) {
                const q = query(collection(firestore, "users"),
                    where("displayNameLower", "==", displayName.toLowerCase()));
                const docs = await getDocs(q);

                setNameFind({
                    text: docs.size === 0 ? "✔ Name Available" : "❌ Name Not Available",
                    status: docs.size === 0
                });

                if (props.changeStatus) {
                    props.changeStatus(docs.size === 0);
                }

            }
        }, 1000);

        return () => {
            clearTimeout(timer);
        }
    }, [displayName, firestore, props]);

    return <div id="change-name-container">
        <div id="change-name-input">
            <p style={{ color: nameFind.status !== null ? nameFind.status ? "lime" : "red" : "yellow" }}>
                {nameFind.text}
            </p>
            <input
                value={displayName}
                placeholder="Enter username"
                name="username"
                autoComplete="username"
                spellCheck="false"
                type="text"
                maxLength="20"
                onChange={(e) => {
                    // limit usernames to alphanumeric, periods and underscores, 20 char length
                    const adjust = e.target.value.match(/[\w.\d]*/g);
                    let string = "";
                    for (let char in adjust) {
                        string += adjust[char];
                    }
                    setDisplayName(string);
                    props.changeName(string);
                    setNameFind({
                        status: null,
                        text: string.length > 0 &&
                            string.toLowerCase() !== props.displayNameLower
                            ? "Checking Availability..." : ""
                    })
                }} />
        </div>
        {
            props.showChangeButton &&
            <Button
                id="change-name-button"
                text="Change Username"
                onClick={async (e) => {
                    e.preventDefault();
                    if ((nameFind.status === null && displayName !== props.displayName)
                        || nameFind.status) {   // only cause read/write if a change is present
                        props.onSubmit(displayName);
                    }
                }} />
        }
    </div>
}